module.exports = __webpack_public_path__ + "static/media/banner_ley_21420_mobile.67c67f0b.png";